import { Card, Divider, Stack, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';

import { useContractManagerContext } from '../../hooks/useContractManagerContext';
import ContractAdGroups from './ContractAdGroups';
import ContractLineItemData from './ContractLineItemData';
import ContractTargetedCreatives from './ContractTargetedCreatives';

interface ContractManagerProps {
  tabList?: string[];
}

const DEFAULT_TAB_LIST = ['Line Items', 'Ad Groups', 'Creatives'];

function ContractManager({ tabList = DEFAULT_TAB_LIST }: ContractManagerProps) {
  const { activeTab, setActiveTab, tabIcons } = useContractManagerContext();
  const [tabCounters, setTabCounters] = useState<{ [tab: string]: number }>({});

  return (
    <Card>
      <Stack>
        <Stack>
          <Tabs value={activeTab}>
            {tabList.map((tab) => (
              <Tab
                key={tab}
                label={`${tab} (${tabCounters[tab] || 0})`}
                value={tab}
                sx={{ textTransform: 'none' }}
                onClick={() => setActiveTab(tab)}
                icon={tabIcons[tab] || null}
                iconPosition="end"
              />
            ))}
          </Tabs>
          <Divider />
        </Stack>
        <Stack p={2}>
          <Stack sx={{ display: activeTab === 'Line Items' ? 'inherit' : 'none' }}>
            <ContractLineItemData
              setCount={(count) => setTabCounters((prev) => ({ ...prev, 'Line Items': count }))}
            />
          </Stack>
          <Stack sx={{ display: activeTab === 'Ad Groups' ? 'inherit' : 'none' }}>
            <ContractAdGroups setCount={(count) => setTabCounters((prev) => ({ ...prev, 'Ad Groups': count }))} />
          </Stack>
          <Stack sx={{ display: activeTab === 'Creatives' ? 'inherit' : 'none' }}>
            <ContractTargetedCreatives
              setCount={(count) => setTabCounters((prev) => ({ ...prev, Creatives: count }))}
            />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}

export default ContractManager;
